/**
 * A refused request, shown as the lines `refusalLines` builds: the API's sentence, then each field
 * and why. One `role="alert"` block, one paragraph per line.
 */
import { useTranslation } from 'react-i18next';
import { refusalLines, type RefusalOptions } from '../i18n/refusal.js';

export function RefusalAlert(props: {
  readonly error: unknown;
  readonly options?: RefusalOptions;
  readonly className?: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const lines = refusalLines(t, props.error, props.options);
  return (
    <div className={props.className} role="alert">
      {lines.map((line) => (
        <p key={line}>{line}</p>
      ))}
    </div>
  );
}
